import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import DragHandle from './DragHandle';

const SortableItem = SortableElement(({ value }) => (
  <li className="sortable-list-item">
    <DragHandle />
    <div className="sortable-list-item-content">
      {value}
    </div>
  </li>
));

export default SortableItem;



// WEBPACK FOOTER //
// ./library/app/components/Global/Sortable/SortableItem.js